<template>
  <div id="app">
    <AppLayout>
    </AppLayout>
  </div>
</template>

<script>
import AppLayout from "./layout/layout";
export default {
  name: "App",
  components: {
    AppLayout
  },
  mounted() {
  }
};

</script>

<style scoped>
#app{
    min-width: 1200px;
}
</style>
